import { render, staticRenderFns } from "./VesselPrintAgePieChart.vue?vue&type=template&id=b23d380a&scoped=true&"
import script from "./VesselPrintAgePieChart.vue?vue&type=script&lang=js&"
export * from "./VesselPrintAgePieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b23d380a",
  null
  
)

export default component.exports